import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { BookCalendlyLink } from 'routes/components/Shared'
import { differenceSolutionData } from './solutionData'
import classes from './DifferenceSolution.module.scss'

export const DifferenceSolution = () => {
  return (
    <Block as={'section'} variant={'shadow'} className={classes.section}>
      <div className={classes.content}>
        <Heading as={'h2'} size={'xl'} center balance>
          The only integration solution you don't outgrow
        </Heading>
        <ul className={classes.list}>
          {differenceSolutionData.map(({ title, features }, index) => (
            <li key={`difference-${index}`} className={classes.item}>
              <Heading as={'h3'} size={'xs'} center className={classes.caption}>
                {title}
              </Heading>
              <ul className={classes.featuresList}>
                {features.map(({ Icon, description }, featureIndex) => (
                  <li
                    key={`feature-${index}-${featureIndex}`}
                    className={classes.featuresItem}
                  >
                    <Icon />
                    <Text lh={'tight'} className={classes.featuresText}>
                      {description}
                    </Text>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <BookCalendlyLink type={'primary'}>Book a demo</BookCalendlyLink>
      </div>
    </Block>
  )
}
